import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { BookShort } from '../common/Models/Books';
import { useAuth } from '../common/Auth/AuthProvider';
import ROUTES from '../common/Routing/Routes';
import './BookCard.css';

type Props = {
  book: BookShort;
};

function BookCard({ book }: Props) {
  const authorLine = book.authors.map(author => author.name).join(', ');
  const { user } = useAuth();
  const isAdmin = user?.role === 'Admin';
  const adminEditUrl = `${ROUTES.ADMIN}?tab=books&bookId=${book.id}`;

  return (
    <article className="collection-card">
      {isAdmin && (
        <Tooltip title="Редагувати книгу">
          <IconButton
            aria-label={`Редагувати ${book.name} в адмінці`}
            className="collection-card-admin-edit"
            component="a"
            href={adminEditUrl}
            rel="noopener noreferrer"
            target="_blank"
            size="small"
          >
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}

      <Link className="collection-card-main" to={`${ROUTES.DETAILS}/${book.id}`}>
        <div className="collection-card-cover">
          <span>{book.name.charAt(0)}</span>
        </div>
        <div className="collection-card-copy">
          <h3>{book.name}</h3>
          <p>{authorLine || 'Автор не вказаний'}</p>
          <div className="collection-card-meta">
            <span>{book.stockCount > 0 ? 'Доступна' : 'В оренді'}</span>
            {book.rating ? <span>{book.rating.toFixed(1)}</span> : null}
          </div>
        </div>
      </Link>
    </article>
  );
}

export default BookCard;
